import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home';
import { beforeEach, afterEach, scrollBehavior } from '@/router/permissions';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    props: { test: 'test1' },
  },
  {
    // route level code-splitting
    // this generates a separate chunk for this route
    // which is lazy-loaded when the route is visited.
    path: '/dashboard',
    name: 'Dashboard',
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
  },
  {
    path: '/leaderboard',
    name: 'Leadboard',
    component: () =>
      import(/* webpackChunkName: "leadboard" */ '../views/Leadboard.vue'),
  },
  {
    path: '/tournaments',
    name: 'Tournaments',
    component: () =>
      import(/* webpackChunkName: "tournaments" */ '../views/Tournaments.vue'),
  },
  {
    path: '/referrals',
    name: 'Referrals',
    component: () =>
      import(/* webpackChunkName: "referrals" */ '../views/Referrals.vue'),
  },
  {
    path: '/settings/:option?',
    name: 'Settings',
    component: () =>
      import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
  },
  {
    path: '/sign-up',
    name: 'SignUp',
    component: () =>
      import(/* webpackChunkName: "sign-up" */ '../views/SignUp.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "sign-up" */ '../views/Login.vue'),
    props: { test: 'test2' },
  },
  {
    path: '/registration',
    name: 'Registration',
    component: () =>
      import(
        /* webpackChunkName: "registration" */ '../views/Registration.vue'
      ),
  },
  {
    path: '/reset',
    name: 'Reset',
    component: () =>
      import(/* webpackChunkName: "reset" */ '../views/ResetPassword.vue'),
  },
  {
    path: '/oauth/:operator',
    name: 'Oauth',
    component: () =>
      import(/* webpackChunkName: "oauth" */ '../views/Oauth.vue'),
  },
  {
    path: '/connect/:platform',
    name: 'ConnectPlatform',
    component: () =>
      import(
        /* webpackChunkName: "connect-platform" */ '../views/ConnectPlatform.vue'
      ),
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: () =>
      import(/* webpackChunkName: "wallet" */ '../views/Wallet.vue'),
  },
  {
    path: '/onboarding/:option?/:game?',
    name: 'Onboarding',
    component: () =>
      import(/* webpackChunkName: "onboarding" */ '../views/Onboarding.vue'),
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () =>
      import(/* webpackChunkName: "terms" */ '../views/TermsView.vue'),
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: () =>
      import(/* webpackChunkName: "unsubscribe" */ '../views/Unsubscribe.vue'),
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import(/* webpackChunkName: "test" */ '../views/Test.vue'),
  },
  {
    path: '/404',
    name: 'ErrorPage',
    component: () =>
      import(/* webpackChunkName: "ErrorPage404" */ '../views/ErrorPage.vue'),
  },
  {
    path: '/coming-soon',
    name: 'ComingSoon',
    component: () => import('../views/ComingSoon.vue'),
  },
  {
    path: '*',
    redirect: '/404',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
});

/* path watcher */
router.beforeEach(beforeEach);
router.afterEach(afterEach);

export default router;
